import template from './paymentMethod.html' with { type: 'html' };

export default {
	name: 'CPaymentMethod',
	props: {
		app: {
			type: Object,
			default: () => null
		},
		disabled: {
			type: Boolean,
			default: false
		},
		isPreselection: {
			type: Boolean,
			default: false
		},
		label: {
			type: String,
			default: ''
		},
		labelAria: {
			type: String,
			default: null
		},
		order: {
			type: Object,
			default: () => null
		},
		page: {
			type: Object,
			default: () => null
		},
		payment: {
			type: Object,
			default: () => null
		},
		theme: {
			type: Object,
			default: () => null
		},
		type: {
			type: String,
			required: true
		},
		url: {
			type: Object,
			default: () => null
		},
		value: {
			type: String,
			required: true
		}
	},
	data() {
		return {
			isSelected: this.value === this.type,
			newCartCookieName: 'js-newCart'
		};
	},
	computed: {
		isVisible() {
			const paymentMethod = this.payment.paymentMethods.find((paymentMethod) => paymentMethod.id === this.type);
			return this.order.hasTrialProduct ? paymentMethod.isTrial : true;
		},
		radioValue: {
			get() {
				return this.isPreselection ? '' : this.value;
			},
			set(selectedPaymentMethod) {
				if (this.isPreselection) {
					this.cookieStorage.setItem(this.newCartCookieName, this.app.session?.id, {
						path: '/'
					});
					this.$store.commit('SET_NEW_CART', false);
					this.tracking.freeTrialEnd({
						order: this.order
					}, selectedPaymentMethod);
					// Track a new step (6 - Billing Info) after PM selection
					this.tracking.checkout({
						app: this.app,
						url: this.url,
						page: {
							...this.page,
							number: 6
						},
						order: this.order,
						theme: this.theme
					});
				}
				this.$emit('change', this.type);
			}
		},
		isBoleto() {
			return this.value === 'boleto';
		}
	},
	watch: {
		value(newValue) {
			this.isSelected = newValue === this.type;
		}
	},
	template
};
